const EVENT = "mc-cases-changed";

/** Tell an already-open Cases page that a new case was created. */
export function notifyCasesChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeCasesChanged(handler) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
